import con from '../../../../connection';
var path = '/buildingtypes';
var buildingtypes = function (url) { return function () { return ({
    get: function (options) { return con.get(url + path, {}, options === null || options === void 0 ? void 0 : options.noError, options === null || options === void 0 ? void 0 : options.noNetworkError); },
}); }; };
export default buildingtypes;
